import {copyToClipboard, Flag, IconButton, TableRow} from 'platform/components';
import {Box, HStack, Icon, Show, Text, VStack} from 'platform/foundation';

import {BranchLeadAddressResponseBody} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface BranchLeadAddressRowProps extends RequiredTestIdProps {
  branchLeadAddress: BranchLeadAddressResponseBody & {emailAddress: string};
  lengthLimit: number;
}

export function BranchLeadAddressRow(props: BranchLeadAddressRowProps) {
  const emailAddress = props.branchLeadAddress.emailAddress;

  return (
    <TableRow data-testid={props['data-testid']}>
      <Box padding={2}>
        <HStack spacing={2} align="center">
          <Box minWidth={0}>
            <Text size="small" noWrap data-testid={suffixTestId('branchName', props)}>
              {props.branchLeadAddress.branchName}
            </Text>
          </Box>
          <Show when={!props.branchLeadAddress.isBranchActive}>
            <Box flexShrink={0}>
              <Flag
                label={i18n.t('entity.employee.labels.flagInactive')}
                colorScheme="neutral"
                isSubtle
                size="small"
                data-testid={suffixTestId('inactiveFlag', props)}
              />
            </Box>
          </Show>
        </HStack>
      </Box>

      <Box padding={2}>
        <VStack spacing={1}>
          <HStack spacing={2} align="center">
            <Text
              size="small"
              overflowWrap="anywhere"
              data-testid={suffixTestId('emailAddress', props)}
            >
              {emailAddress}
            </Text>
            <Box flexShrink={0}>
              <IconButton
                icon="content/copy"
                priority="secondary"
                size="small"
                onClick={() => copyToClipboard(emailAddress)}
                aria-label={i18n.t('general.actions.copyToClipboard')}
                data-testid={suffixTestId('copy', props)}
              />
            </Box>
          </HStack>
          <Show when={props.branchLeadAddress.exceedsLengthLimit}>
            <HStack spacing={1} align="center">
              <Icon value="alert/warning" size={3} color="text.warning" />
              <Text size="xSmall" color="warning" data-testid={suffixTestId('tooLong', props)}>
                {i18n.t('page.settings.labels.aiLeadManagementBranchLeadAddressTooLong', {
                  max: props.lengthLimit,
                })}
              </Text>
            </HStack>
          </Show>
        </VStack>
      </Box>
    </TableRow>
  );
}
